module.exports = __webpack_public_path__ + "img/gonggao.d7fff504.png";